import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { PartnerStatisticsPage } from "Partner/Modules/Statistics/Pages/Statistics";
import { PartnerStatisticsPaths } from "Partner/Modules/Statistics/Routes/Routing";

export const PartnerStatisticsRoutes = [
	{
		path: PartnerStatisticsPaths.Index.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerStatisticModule.read}>
				<PartnerStatisticsPage />
			</PermissionGuard>
		),
	},
];
